import { Query } from 'acast-reactor';
import request from 'superagent';
import { getUserToken } from 'services/authentication';
import Config from 'app/config';

export default Query.define('episode/create', {
  cache: false,

  execute: episode =>
    new Promise((resolve, reject) => {
      const API_HOST = Config.get('CREATE_API_HOST');

      request
        .post(`${API_HOST}/api-v2/acasts`)
        .set('Authorization', `Bearer ${getUserToken()}`)
        .send(episode)
        .end((err, res) => {
          if (err) {
            return reject(err);
          }
          return resolve(res.body);
        });
    }),
});
